// Photon's UI faces: Roboto (labels, buttons) and Roboto Mono (timecode, file
// name), served as woff2 next to widget.js (scripts/fonts.ts). @font-face
// inside a shadow root is unreliable across browsers, so the rules are
// injected once into the host document under widget-specific family names
// that cannot collide with a page's own Roboto.

export const FONT_UI =
  "'Photon Roboto', Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif";
export const FONT_MONO =
  "'Photon Roboto Mono', 'Roboto Mono', ui-monospace, Menlo, Consolas, monospace";

const STYLE_ID = 'photon-widget-fonts';

const FACES: Array<{ family: string; weight: number; file: string }> = [
  { family: 'Photon Roboto', weight: 400, file: 'roboto-400.woff2' },
  { family: 'Photon Roboto', weight: 700, file: 'roboto-700.woff2' },
  { family: 'Photon Roboto Mono', weight: 400, file: 'roboto-mono-400.woff2' },
];

// Resolves relative to the host page; absolute CDN URLs pass through.
function resolveFontUrl(fontsUrl: string, file: string): string {
  const base = new URL(fontsUrl.endsWith('/') ? fontsUrl : `${fontsUrl}/`, document.baseURI);
  return new URL(file, base).href;
}

export function installFonts(fontsUrl: string): void {
  if (!fontsUrl || typeof document === 'undefined') return;
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = FACES.map(
    (f) => `@font-face{font-family:'${f.family}';font-style:normal;font-weight:${f.weight};` +
      `font-display:swap;src:url("${resolveFontUrl(fontsUrl, f.file)}") format("woff2");}`,
  ).join('\n');
  document.head.appendChild(style);
}

// Where the fonts live when nothing says otherwise: a fonts/ folder beside the
// bundle (the handoff's production/ layout). In the Vite dev server the module
// URL points into src/, so index.html passes fonts-url="/fonts/" explicitly.
export function defaultFontsUrl(): string {
  try {
    return new URL('fonts/', import.meta.url).href;
  } catch {
    return '';
  }
}
